/**
 * P9-1: プレイスルー（1回の通しプレイ）毎に一意な id を採番する。
 *
 * 図鑑（utils/collection.ts）の冪等キー（recordedRunIds）に使う。
 * mock 経路の runtime context.runId は固定文字列（'mock-run' / 'preview-run' / 'restored-run'）で
 * ラン毎に一意でないため、そのまま冪等キーにすると2周目以降が全て no-op になり周回カウントが死ぬ。
 * そこでプレイスルー単位の id を App 層で採番し、進行保存（player_progress_*）へ載せる:
 * - 新規開始（最初から）: 再採番
 * - 続きから: 進行保存に載せた id を復元（同一プレイスルーとして維持）
 * - live 経路: サーバ採番の runId がラン毎に一意なのでそちらを優先する（App.tsx 側で選択）
 */
export function mintPlaythroughId(): string {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return `pt_${crypto.randomUUID()}`;
    }
  } catch {
    // fallthrough（crypto アクセス不可の環境はフォールバックへ）
  }
  // crypto.randomUUID 非対応環境（旧 WebView 等）向けフォールバック。
  // 時刻 + 乱数36進で、冪等キー用途（同一端末内の衝突回避）には実用上十分。
  return `pt_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
}
